import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
} from "../../Constant/Global";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditVillageSummary = () => {
  const { id } = useParams("");
  const navigate = useNavigate("");
  const [title, setTitle] = useState("");
  const [titleError, setTitleError] = useState("");
  const [count, setCount] = useState("");
  const [countError, setCountError] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImage1, setSelectedImage1] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState("Y");

  const userDataInfo = sessionStorage.getItem("info");
  const userDetails = JSON.parse(userDataInfo);

  const handleStatus = (e) => {
    setStatus(e.target.value);
  };

  const handleImageRemove = () => {
    setSelectedImage(null);
    setSelectedImage1(null);
    setErrorMessage("");
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          console.log("img width", img.width);
          console.log("img height", img.height);
          setTimeout(() => {
            if (
              img.width >= 40 &&
              img.width <= 90 &&
              img.height >= 40 &&
              img.height <= 90
            ) {
              setSelectedImage(e.target.result);
              setErrorMessage("");
            } else {
              setErrorMessage(
                `कृपया Images ची hight हि 40px पेक्षा जास्त आणि 90px पेक्षा कमी असावी आणि width हि 40px पेक्षा जास्त आणि 90px पेक्षा कमी असावी.`
              );
              setTimeout(() => {
                alert(
                  `तुमी select केलेली height ${img.height} आणि width ${img.width}`
                );
              }, 2000);
            }
          }, 100);
        };
      };
      reader.readAsDataURL(file);
    }
  };

  // validation

  const validation = () => {
    let valid = true;
    if (!title) {
      setTitleError("Title is required");
      valid = false;
    } else {
      setTitleError("");
    }
    if (!count) {
      setCountError("Count is required");
      valid = false;
    } else {
      setCountError("");
    }
    return valid;
  };

  // handle details of member

  useEffect(() => {
    const handleFacilitiesDetails = async () => {
      const finalData = {
        gram_panchayat_overview_id: id,
      };
      try {
        const response = await axios.post(
          API_BASE_URL + "api/gram_panchayat_overview_details_by_id",
          finalData,
          {
            auth: {
              username: API_AUTH_USERNAME,
              password: API_AUTH_PASSWORD,
            },
          }
        );
        console.log("response of overview details by id data", response.data);
        // setEditDetails(response.data.data);
        setTitle(response.data.data.title);
        setCount(response.data.data.count);
        if (response.data.data.image) {
          setSelectedImage1(response.data.data.image);
        }
        setStatus(response.data.data.status);
      } catch (error) {
        console.log("errror occured fetching data", error);
      }
    };

    handleFacilitiesDetails();
  }, [id]);

  // edit schemes api

  const handleEditFacilities = async (e) => {
    e.preventDefault();
    if (validation()) {
      if (errorMessage) {
        alert(errorMessage);
      } else {
        try {
          const finalData = {
            admin_id: userDetails.id,
            gram_panchayat_overview_id: id,
            title: title,
            count: count,
            status: status,
            // image: selectedImage,
          };
          if (selectedImage) {
            finalData.image = selectedImage;
          }
          console.log("edit final data", finalData);

          const response = await axios.post(
            API_BASE_URL + "api/edit_gram_panchayat_overview",
            finalData,
            {
              auth: {
                username: API_AUTH_USERNAME,
                password: API_AUTH_PASSWORD,
              },
            }
          );
          console.log("edit response data", response.data);
          if (response.data.status === true) {
            toast.success(response.data.message);
            setTimeout(() => {
              navigate("/village-summary");
            }, 2000);
          } else {
            toast.error(response.data.message);
          }
        } catch (error) {
          console.log("error occur in edit data", error);
        }
      }
    }
  };

  return (
    <div className="container">
      <div className="row h-100">
        <div className="col-lg-12 d-flex justify-content-center align-items-center">
          <div className="input_wrappers">
            <div className="wrapper_title">
              <h4>Edit Village Summary</h4>
            </div>
            <form onSubmit={handleEditFacilities}>
              <div className="input_group">
                <div className="label_sec">
                  <label className="input_label">Photos :-</label>
                </div>
                <div className="input_sec">
                  {selectedImage1 && !selectedImage && (
                    <div className="selected_img_group">
                      <img
                        src={selectedImage1}
                        alt="Selected"
                        className="img-fluid bg-black"
                      />
                      <button
                        onClick={handleImageRemove}
                        className={`btn remove_banner_btn`}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                  {selectedImage && !selectedImage1 && (
                    <div className="selected_img_group">
                      <img
                        src={selectedImage}
                        alt="Selected"
                        className="img-fluid bg-black"
                      />
                      <button
                        onClick={handleImageRemove}
                        className={`btn remove_banner_btn`}
                      >
                        Remove
                      </button>
                    </div>
                  )}
                  {!selectedImage1 && !selectedImage && (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                        className={`form-control common_input`}
                      />
                      {errorMessage && (
                        <p className="banner_error_text">{errorMessage}</p>
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className="input_group">
                <div className="label_sec">
                  <label className="input_label">Title :-</label>
                </div>
                <div className="input_sec">
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="common_input form-control"
                  />
                  {titleError && (
                    <span className="banner_error_text">{titleError}</span>
                  )}
                </div>
              </div>
              <div className="input_group">
                <div className="label_sec">
                  <label className="input_label">Count :-</label>
                </div>
                <div className="input_sec">
                  <input
                    type="text"
                    value={count}
                    onChange={(e) => setCount(e.target.value)}
                    className="common_input form-control"
                  />
                  {countError && (
                    <span className="banner_error_text">{countError}</span>
                  )}
                </div>
              </div>
              <div className="input_group">
                <div className="label_sec">
                  <label className="input_label">Status :-</label>
                </div>
                <div className="input_sec">
                  <div className="status-group">
                    <div className="active-sec">
                      <input
                        type="radio"
                        name="status"
                        value="Y"
                        checked={status === "Y"}
                        onChange={handleStatus}
                        className="me-2"
                      />
                      <span>Active</span>
                    </div>
                    <div className="deactive-sec">
                      <input
                        type="radio"
                        name="status"
                        value="N"
                        checked={status === "N"}
                        onChange={handleStatus}
                        className="me-2"
                      />
                      <span>DeActive</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="input_group">
                <button className="input_add_btn">Save</button>
              </div>
            </form>
            <div className="note_sec text-center">
              <p className="note_para">
                Note :-{" "}
                <span className="note_span">
                  कृपया Images ची hight हि 40px पेक्षा जास्त आणि 90px पेक्षा कमी
                  असावी आणि width हि 40px पेक्षा जास्त आणि 90px पेक्षा कमी
                  असावी.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position={"top-right"}
        autoClose={2000}
        pauseOnHover={false}
        closeOnClick={true}
      />
    </div>
  );
};

export default EditVillageSummary;
